import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import { defineComponent, ref } from "vue";
export default defineComponent({
  name: "list-head",
  props: {
    /* 左边分类 */
    leftTitle: {
      type: Array,
      default: function _default() {
        return [];
      }
    },

    /* 右边分类 */
    rightTitle: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit;
    //存储标签id
    var tag = ref([-1, -1, -1]);
    /* 标签点击事件 */

    var titleClick = function titleClick(index1, itemB) {
      var _itemB$id;

      tag.value[index1] = (_itemB$id = itemB.id) !== null && _itemB$id !== void 0 ? _itemB$id : itemB;
      tag.value = Array.from(tag.value);
      emit("tagClick", tag.value);
    };

    return {
      tag: tag,
      titleClick: titleClick
    };
  },
  components: {}
});